import { Heart } from "lucide-react";

const supporters = [
  { name: "Anonymous", amount: "$500" },
  { name: "John D.", amount: "$250" },
  { name: "Tech Corp", amount: "$1,000" },
  { name: "Sarah M.", amount: "$100" },
  { name: "Community Fund", amount: "$750" },
];

const SupportersCard = () => {
  return (
    <div className="card-elevated p-6">
      <div className="flex items-center gap-2 mb-5">
        <div className="w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center">
          <Heart size={18} className="text-primary" />
        </div>
        <h3 className="text-lg font-heading font-semibold text-foreground">
          Supporters
        </h3>
      </div>

      <ul className="space-y-3">
        {supporters.map((supporter, index) => (
          <li
            key={index}
            className="flex items-center justify-between p-3 rounded-lg hover:bg-muted/50 transition-colors"
          >
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-full bg-gradient-to-br from-primary to-accent flex items-center justify-center text-sm font-semibold text-primary-foreground">
                {supporter.name.charAt(0)}
              </div>
              <span className="text-foreground">{supporter.name}</span>
            </div>
            <span className="text-sm font-semibold text-primary">
              {supporter.amount}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SupportersCard;
